import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-empty-component',
  template: `<span class="c-field-value__text -light-gray" i18n="@@common.empty">Empty</span> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultEmptyComponent {}
